(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-comparison"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tl-comparison')) {
 customElements.define('tl-comparison', class extends HTMLElement {
  connectedCallback() {
   if (this.bound) return;
   this.bound = true;
   const slider = this.querySelector('input');
   slider.addEventListener('input', () => this.style.setProperty('--tl-position', `${slider.value}%`));
  }
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-installations"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('tl-case-carousel')){customElements.define('tl-case-carousel',class extends HTMLElement{
 connectedCallback(){this.abort?.abort();this.abort=new AbortController();this.track=this.querySelector('.tl-installation-track');this.cards=[...this.track.children];this.querySelectorAll('[data-direction]').forEach(b=>b.addEventListener('click',()=>{const step=this.cards[0]?.getBoundingClientRect().width||300;this.track.scrollBy({left:Number(b.dataset.direction)*(step+14),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});},{signal:this.abort.signal}));this.track.addEventListener('scroll',()=>{if(this.frame)return;this.frame=requestAnimationFrame(()=>{this.frame=null;const step=(this.cards[0]?.getBoundingClientRect().width||300)+14;const i=Math.round(this.track.scrollLeft/step);this.querySelectorAll('.tl-gallery-dots span').forEach((s,k)=>s.classList.toggle('is-active',i===k));});},{passive:true,signal:this.abort.signal});}
 disconnectedCallback(){this.abort?.abort();if(this.frame)cancelAnimationFrame(this.frame);}
});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-tailbag-cards"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('tl-tailbag-carousel')){customElements.define('tl-tailbag-carousel',class extends HTMLElement{
connectedCallback(){if(this.ready)return;this.ready=true;this.track=this.querySelector('[data-track]');this.prev=this.querySelector('[data-prev]');this.next=this.querySelector('[data-next]');this.update=()=>{const max=this.track.scrollWidth-this.track.clientWidth;this.prev.disabled=this.track.scrollLeft<2;this.next.disabled=this.track.scrollLeft>=max-2;const card=this.track.querySelector('article');const index=card?Math.round(this.track.scrollLeft/(card.getBoundingClientRect().width+parseFloat(getComputedStyle(this.track).gap))):0;this.querySelectorAll('.tl-bag-pips span').forEach((p,i)=>p.classList.toggle('is-active',i===index));};this.move=(direction)=>{const card=this.track.querySelector('article');if(card)this.track.scrollBy({left:direction*(card.getBoundingClientRect().width+parseFloat(getComputedStyle(this.track).gap)),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});};this.prev.addEventListener('click',()=>this.move(-1));this.next.addEventListener('click',()=>this.move(1));this.track.addEventListener('scroll',this.update,{passive:true});this.observer=new ResizeObserver(this.update);this.observer.observe(this.track);this.update();}
disconnectedCallback(){this.observer?.disconnect();this.ready=false;}
});}

  } catch(e) { console.error(e); }
})();
})();
